export const QUERY_DEBUG_PARAM = /(&debug|\?debug){1}/i
